import React, { useEffect, useState } from "react"
import { BsPlusLg } from "react-icons/bs"
import Address from "../checkout/Address"

const AddressTab = ({
  customer,
  createCustomerAddress,
  updateCustomerAddress,
  deleteCustomerAddress,
  isFetching,
}) => {
  const initState = {
    first_name: "",
    last_name: "",
    company: "",
    address1: "",
    address2: "",
    city: "",
    state_or_province: "",
    postal_code: "",
    country_code: "",
    phone: "",
    customer_id: customer?.id,
  }

  const [selectedAddress, setSelectedAddress] = useState(null)
  const [isNewAdd, setIsNewAdd] = useState(false)
  const [fields, setFields] = useState(initState)
  const [states, setStates] = useState([])
  const [countries, setCountries] = useState([])

  useEffect(() => {
    if (isNewAdd) {
      getCountries()
    }
  }, [isNewAdd])

  useEffect(() => {
    if (countries.length && fields?.country_code) {
      getStates(fields?.country_code)
    }
  }, [countries, fields?.country_code])

  useEffect(() => {
    if (selectedAddress) {
      setFields(selectedAddress)
      setIsNewAdd(true)
    }
  }, [selectedAddress])

  async function getCountries() {
    setCountries([])
    setStates([])

    const res = await fetch(
      `/.netlify/functions/bigcommerce?endpoint=/v2/countries?limit=250`,
      { credentials: "same-origin", mode: "same-origin" }
    )

    if (res.status === 200) {
      const response = await res.json()
      setCountries(response)
    }
  }

  async function getStates(country_code) {
    const country = countries.find(el => el.country_iso2 === country_code)
    if (country) {
      const res = await fetch(
        `/.netlify/functions/bigcommerce?endpoint=/v2${country.states.resource}?limit=250`,
        { credentials: "same-origin", mode: "same-origin" }
      )

      if (res.status === 200) {
        const response = await res.json()
        setStates(response)
      }
    }
  }

  function handleChange({ target }) {
    const { name, value } = target
    setFields(prev => ({ ...prev, [name]: value }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (selectedAddress) {
      await updateCustomerAddress([{ ...fields, customer_id: customer?.id }])
    } else {
      await createCustomerAddress([fields])
    }
    setIsNewAdd(false)
    setSelectedAddress(null)
  }

  if (isNewAdd) {
    return (
      <div className="w-100 m-auto" style={{ maxWidth: 700 }}>
        <form className="mt-3" onSubmit={handleSubmit}>
          <Address
            fields={fields}
            handleChange={handleChange}
            countries={countries}
            states={states}
          />

          {isFetching ? (
            <p className="text-center">Loading..</p>
          ) : (
            <div className="text-center">
              <button
                className="btn btn-outline-dark mr-3"
                onClick={() => setIsNewAdd(false)}
              >
                Cancel
              </button>
              <button className="btn btn-dark" type="submit">
                {selectedAddress ? "Update" : "Save"}
              </button>
            </div>
          )}
        </form>
      </div>
    )
  }

  return (
    <div className="row border-bottom py-3">
      {customer?.addresses.map(add => (
        <div className="col-md-3 mb-3" key={add.id}>
          <div className="bg-light p-3">
            <p>{[add.first_name, add.last_name].join(" ")}</p>
            <p className="mb-0 d-flex flex-column">
              <span className="small">{add.address1}</span>
              {add.address2 && <span className="small">{add.address2}</span>}
              <span className="small">{`${add.city}, ${add.state_or_province} ${add.postal_code}`}</span>
              <span className="small">{add.country}</span>
            </p>

            <div className="mt-3">
              <button
                className="btn btn-dark mr-2"
                onClick={() => {
                  setSelectedAddress(add)
                }}
              >
                Edit
              </button>
              <button
                className="btn btn-outline-dark"
                onClick={() => deleteCustomerAddress(add.id)}
                disabled={isFetching === add.id}
              >
                {isFetching === add.id ? "Deleting.." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      ))}
      <div className="col-md-3">
        <NewAddress
          setIsNewAdd={val => {
            setIsNewAdd(val)
            setFields(initState)
          }}
        />
      </div>
    </div>
  )
}

const NewAddress = props => {
  return (
    <div
      className="d-flex align-items-center justify-content-center flex-column border"
      style={{ minHeight: 150, cursor: "pointer" }}
      onClick={() => props.setIsNewAdd(true)}
    >
      <span>
        <BsPlusLg style={{ fontSize: 30 }} />
      </span>
      <p className="mb-0">New Address</p>
    </div>
  )
}

export default AddressTab
